import React from "react"

interface ActionsRowProps {
  children: React.ReactNode
  className?: string
}

export function ActionsRow({
  children,
  className,
}: ActionsRowProps): JSX.Element {
  const classes = className
    ? `flex items-center justify-between ${className}`
    : "flex items-center justify-between"

  return <div className={classes}>{children}</div>
}
